module.exports = __webpack_public_path__ + "media/logos/bloomberg-law-logo-black-ab66a868.svg";